// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2w1DJ","header":"ReportDetails_header__2i_At","title":"ReportDetails_title__3TWnb","left":"ReportDetails_left__2LlFh"};